// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinUserToSubOrganizationStyle_container__2Fpu4","button":"JoinUserToSubOrganizationStyle_button__3bCWc","title":"JoinUserToSubOrganizationStyle_title__1zuV8"};